import { withPrefix } from "gatsby";
import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {
    color: #fff !important;
    background-position: right;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    margin: 0px;
    font-family: sofia-pro, sans-serif;

    ${({ darkMode }) =>
      darkMode &&
      `
      background-image: none !important;
      background-color: #404042 !important;
      color: white !important;
    `}
  }

  .socials{
    position: fixed;
    top: 50%;
    margin-top: -100px;
    right: 5px;
    z-index: 100;
  }

  @media (max-width: 480px) {
    body {
      background-position-x: 0, 0;
      background-position-y: 85px, bottom;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  @media (min-width: 481px) and (max-width: 1024px) {
    body {
      background-position-x: 0, 0;
      background-position-y: 85px, calc(100vh + 580px);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  @media (min-width: 1025px) {
    body {
      background-position-x: 0, 0;
      background-position-y: 50px, calc(100vh - 300px);
      background-size: contain;
      background-repeat: no-repeat;
   }
  }
  @media only screen and (min-width: 1508px){
    body{
      background-position-x: 0, 0;
      background-position-y: 50px, calc(100vh - 300px);
    }
  }


  @media only screen and (max-width: 1268px){
    body{
      background-position-y: 85px, calc(100vh - 70px);
    }
  }
  @media only screen and (max-width: 1024px) and (max-height: 1366px){
    body{
      background-position-y: 85px, bottom;
    }
  }
  @media only screen and (max-width: 960px){
    body{
      background-position-y: 85px, calc(100vh + 480px);
    }
  }
  @media only screen and (max-width: 768px){
    body{
      background-position-y: 85px, calc(100vh + 590px);
    }
  }
  @media only screen and (max-width: 540px) and (max-height: 720px){
    body{
      background-position-y: 85px, calc(100vh + 930px);
    }
  }
  @media only screen and (max-width: 414px) and (max-height: 736px){
    body{
      background-position-y: 85px, calc(100vh + 930px);
    }
  }
  @media only screen and (max-width: 411px){
    body{
      background-position-y: 85px, calc(100vh + 930px);
    }
  }

  @media only screen and (max-width: 411px) and (max-height: 823px){
    body{
      background-position-y: 85px, calc(100vh + 830px);
    }
  }
  @media only screen and (max-width: 411px) and (max-height: 731px){
    body{
      background-position-y: 85px, calc(100vh + 930px);

    }
  }
  @media only screen and (max-width: 375px){
    body{
      background-position-y: 85px, calc(100vh + 870px);
    }
  }
  @media only screen and (max-width: 375px) and (max-height: 667px){
    body{
      background-position-y: 85px, calc(100vh + 1020px);
    }
  }
  @media only screen and (max-width: 360px){
    body{
      background-position-y: 85px, calc(100vh + 1050px);
    }
  }
  @media only screen and (max-width: 320px){
    body{
      background-position-y: 85px, calc(100vh + 1220px);
    }
  }
  @media only screen and (max-width: 280px) and (max-height: 653px){
    body{
      background-position-y: 85px, calc(100vh + 1120px);
    }
  }
  @media (min-width: 1600px) {
    body {
      background-position-x: 0, 0;
      background-position-y: -20px, 650px;
      background-size: contain;
      background-repeat: no-repeat;
   }
  }
`;

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  align-self: stretch;
  height: 100vh;

  .content {
    flex-grow: 1;
    width: 100%;
    align-items: stretch;
    align-content: stretch;
  }
`;
